import React, { useEffect } from 'react';
import { HashRouter, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { syncPathname } from '../libs/nexo/helpers';
import nexo from '../nexoClient';
import ProductCreateWidget from '../Products/ProductCreateWidget';
import ProductListPage from '../Products/ProductListPage';

function NexoSyncRoute({ children }: { children: JSX.Element }) {
  const { pathname } = useLocation();
  useEffect(() => {
    syncPathname(nexo, pathname);
  }, [pathname]);
  return children
}

function Routes(): JSX.Element {

  return (
    <HashRouter>
      <NexoSyncRoute>
        <Switch>
          <Route path="/products/:id">
            <ProductCreateWidget />
          </Route>
          <Route path="/products">
            <ProductListPage />
          </Route>
          <Redirect from="*" to="/products" />
        </Switch>
      </NexoSyncRoute>
    </HashRouter >
  );
}

export default Routes;
